import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PlatformId = Brand<number, 'PlatformId'>;
export const PlatformId = createBranded<PlatformId>();
